/**
 * AdminBillingRpcClient - AtomRpc integration for admin billing endpoints
 *
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminBillingRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminBillingRpcClient extends AtomRpc.Tag<AdminBillingRpcClient>()(
  "AdminBillingRpcClient",
  {
    group: AdminBillingRpcs,
    protocol: makeRpcClientLayer(AdminBillingRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
